

export const remToPx = (rem: number) => {
    const baseFontSize = 16; // Tamaño de fuente raíz en píxeles
    return rem * baseFontSize;
};

export const addCharactersToString = (text: string, totalCharacters: number): string => {
    const finalTotalCharacters = totalCharacters - text.length;
    if (finalTotalCharacters < 0 ) {
      console.warn('La cantidad de espacios no puede ser negativa');
      return text;
    }
    const espacios = ' '.repeat(finalTotalCharacters);
    return espacios + text;
};